import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives, createVNode as _createVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "on-screen-debugger-root",
  dir: "ltr"
}
const _hoisted_2 = {
  class: "on-screen-debugger",
  dir: "ltr"
}
const _hoisted_3 = { class: "on-screen-debugger__toolbar" }
const _hoisted_4 = { class: "on-screen-debugger__toolbar-counts" }
const _hoisted_5 = {
  key: 0,
  class: "on-screen-debugger__toolbar-paused"
}
const _hoisted_6 = { class: "on-screen-debugger__panel" }
const _hoisted_7 = { class: "on-screen-debugger__tabs" }
const _hoisted_8 = {
  ref: "contentRef",
  class: "on-screen-debugger__content"
}
const _hoisted_9 = { class: "on-screen-debugger__list on-screen-debugger__list--console" }
const _hoisted_10 = { class: "on-screen-debugger__time" }
const _hoisted_11 = { class: "on-screen-debugger__msg" }
const _hoisted_12 = {
  key: 0,
  class: "on-screen-debugger__empty"
}
const _hoisted_13 = { class: "on-screen-debugger__list on-screen-debugger__list--network" }
const _hoisted_14 = { class: "on-screen-debugger__col on-screen-debugger__col--time" }
const _hoisted_15 = { class: "on-screen-debugger__col on-screen-debugger__col--domain" }
const _hoisted_16 = { class: "on-screen-debugger__col on-screen-debugger__col--method" }
const _hoisted_17 = ["title"]
const _hoisted_18 = { class: "on-screen-debugger__col on-screen-debugger__col--timing" }
const _hoisted_19 = { class: "on-screen-debugger__col on-screen-debugger__col--size" }
const _hoisted_20 = {
  key: 0,
  class: "on-screen-debugger__empty"
}
const _hoisted_21 = { class: "on-screen-debugger__list on-screen-debugger__list--video" }
const _hoisted_22 = {
  key: 0,
  class: "on-screen-debugger__empty"
}
const _hoisted_23 = { class: "on-screen-debugger__list on-screen-debugger__list--general" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return ($setup.isDeveloper)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _cache[4] || (_cache[4] = _createStaticVNode("<span class=\"on-screen-debugger__toolbar-title\" data-v-158ef2c8>Codes</span><span class=\"on-screen-debugger__toolbar-codes\" data-v-158ef2c8><strong data-v-158ef2c8>1</strong> Toggle panel <strong data-v-158ef2c8>2</strong> Console <strong data-v-158ef2c8>3</strong> Network <strong data-v-158ef2c8>4</strong> Pause <strong data-v-158ef2c8>5</strong> Video <strong data-v-158ef2c8>6</strong> General <strong data-v-158ef2c8>0</strong> Clear all </span>", 2)),
            _createElementVNode("span", _hoisted_4, [
              ($setup.paused)
                ? (_openBlock(), _createElementBlock("span", _hoisted_5, "Paused"))
                : _createCommentVNode("v-if", true),
              _createTextVNode(" " + _toDisplayString($setup.consoleCount) + " logs · " + _toDisplayString($setup.networkCount) + " requests ", 1 /* TEXT */)
            ])
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("button", {
                type: "button",
                class: _normalizeClass(["on-screen-debugger__tab", { 'on-screen-debugger__tab--active': $setup.activeTab === 'console' }]),
                onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.showConsoleTab()))
              }, " Console ", 2 /* CLASS */),
              _createElementVNode("button", {
                type: "button",
                class: _normalizeClass(["on-screen-debugger__tab", { 'on-screen-debugger__tab--active': $setup.activeTab === 'network' }]),
                onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.showNetworkTab()))
              }, " Network ", 2 /* CLASS */),
              _createElementVNode("button", {
                type: "button",
                class: _normalizeClass(["on-screen-debugger__tab", { 'on-screen-debugger__tab--active': $setup.activeTab === 'video' }]),
                onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.showVideoTab()))
              }, " Video ", 2 /* CLASS */),
              _createElementVNode("button", {
                type: "button",
                class: _normalizeClass(["on-screen-debugger__tab", { 'on-screen-debugger__tab--active': $setup.activeTab === 'general' }]),
                onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.showGeneralTab()))
              }, " General ", 2 /* CLASS */)
            ]),
            _createElementVNode("div", _hoisted_8, [
              _withDirectives(_createElementVNode("div", _hoisted_9, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.consoleLogs, (entry) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: entry.id,
                    class: "on-screen-debugger__row on-screen-debugger__row--console"
                  }, [
                    _createElementVNode("span", _hoisted_10, _toDisplayString(entry.time), 1 /* TEXT */),
                    _createElementVNode("span", {
                      class: _normalizeClass(["on-screen-debugger__level", `on-screen-debugger__level--${entry.level}`])
                    }, " [" + _toDisplayString(entry.level.toUpperCase()) + "] ", 3 /* TEXT, CLASS */),
                    _createElementVNode("span", _hoisted_11, _toDisplayString(entry.message), 1 /* TEXT */)
                  ]))
                }), 128 /* KEYED_FRAGMENT */)),
                ($setup.consoleLogs.length === 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_12, " No console entries. Press 2 to focus console. "))
                  : _createCommentVNode("v-if", true)
              ], 512 /* NEED_PATCH */), [
                [_vShow, $setup.activeTab === 'console']
              ]),
              _withDirectives(_createElementVNode("div", _hoisted_13, [
                _cache[5] || (_cache[5] = _createStaticVNode("<div class=\"on-screen-debugger__row on-screen-debugger__row--header\" data-v-158ef2c8><span class=\"on-screen-debugger__col on-screen-debugger__col--time\" data-v-158ef2c8>Time</span><span class=\"on-screen-debugger__col on-screen-debugger__col--domain\" data-v-158ef2c8>Domain</span><span class=\"on-screen-debugger__col on-screen-debugger__col--method\" data-v-158ef2c8>Type</span><span class=\"on-screen-debugger__col on-screen-debugger__col--name\" data-v-158ef2c8>Asset</span><span class=\"on-screen-debugger__col on-screen-debugger__col--status\" data-v-158ef2c8>Status</span><span class=\"on-screen-debugger__col on-screen-debugger__col--timing\" data-v-158ef2c8>Timing</span><span class=\"on-screen-debugger__col on-screen-debugger__col--size\" data-v-158ef2c8>Size</span></div>", 1)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.networkLogs, (entry) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: entry.id,
                    class: _normalizeClass(["on-screen-debugger__row on-screen-debugger__row--network", { 'on-screen-debugger__row--network--failed': $setup.isFailedRequest(entry) }])
                  }, [
                    _createElementVNode("span", _hoisted_14, _toDisplayString(entry.time), 1 /* TEXT */),
                    _createElementVNode("span", _hoisted_15, _toDisplayString(entry.domain), 1 /* TEXT */),
                    _createElementVNode("span", _hoisted_16, _toDisplayString(entry.method), 1 /* TEXT */),
                    _createElementVNode("span", {
                      class: "on-screen-debugger__col on-screen-debugger__col--name",
                      title: entry.name
                    }, _toDisplayString(entry.name), 9 /* TEXT, PROPS */, _hoisted_17),
                    _createElementVNode("span", {
                      class: _normalizeClass(["on-screen-debugger__col on-screen-debugger__col--status", { 'on-screen-debugger__col--status--failed': $setup.isFailedRequest(entry) }])
                    }, _toDisplayString(entry.status), 3 /* TEXT, CLASS */),
                    _createElementVNode("span", _hoisted_18, _toDisplayString(entry.timing), 1 /* TEXT */),
                    _createElementVNode("span", _hoisted_19, _toDisplayString(entry.size), 1 /* TEXT */)
                  ], 2 /* CLASS */))
                }), 128 /* KEYED_FRAGMENT */)),
                ($setup.networkLogs.length === 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_20, " No network entries. Press 3 to focus network. "))
                  : _createCommentVNode("v-if", true)
              ], 512 /* NEED_PATCH */), [
                [_vShow, $setup.activeTab === 'network']
              ]),
              _withDirectives(_createElementVNode("div", _hoisted_21, [
                _createVNode($setup["OnScreenDebuggerVideoTab"]),
                (!$setup.videoTabHasData)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_22, " No video data. Open a stream and press 5 to focus video. "))
                  : _createCommentVNode("v-if", true)
              ], 512 /* NEED_PATCH */), [
                [_vShow, $setup.activeTab === 'video']
              ]),
              _withDirectives(_createElementVNode("div", _hoisted_23, [
                _createVNode($setup["OnScreenDebuggerGeneralTab"])
              ], 512 /* NEED_PATCH */), [
                [_vShow, $setup.activeTab === 'general']
              ])
            ], 512 /* NEED_PATCH */)
          ], 512 /* NEED_PATCH */), [
            [_vShow, $setup.panelExpanded]
          ])
        ])
      ]))
    : _createCommentVNode("v-if", true)
}